<template lang="pug">
.table-row.clickable
  template(v-if="editing")
    .table-col.table-col-120
      .form-group(:class="{'has-error': errors.has('title')}")
        input.form-control(name="title",
                           type="text",
                           v-model="title",
                           v-validate="'required'")
  template(v-else)
    .table-col.table-col-120
      | {{ lost_reason.title }}
  .table-col.table-col-80
    .pull-right(v-if="can_edit_lost_reason")
      button.btn.btn-primary(v-if="editing", @click="submit") Salvar
      button.btn.btn-primary(v-else, @click="editing = !editing") {{ editing ? 'Cancelar' : 'Editar' }}
      button.btn.btn-danger(@click="destroyLostReason") Excluir
</template>

<script>
  import helpers from '../../helpers.coffee'

  const view_model = {
    props: ['lost_reason'],
    data() {
      return {
        title: this.lost_reason.title,
        editing: false
      }
    },

    computed: {
      can_edit_lost_reason() {
        return this.title != 'Blocklist' && this.title != 'Sem Conexão'
      }
    },

    methods: {
      submit() {
        this.$validator.validateAll({title: this.title}).then(success => {
          if (success) {
            this.updateLostCategory()
          }
        })
      },

      updateLostCategory() {
        const params = {id: this.lost_reason.id, title: this.title}
        this.$store.dispatch('updateLostReason', params)
        this.editing = false
      },

      destroyLostReason() {
        this.$emit('destroy', this.lost_reason)
      },

      trackIntercomLostCategoryUpdate(lost_reason) {
        const metadata = [
          { attribute: 'title', key: 'Título', function: 'changedFromTo' }
        ]
        IntercomCtrl.trackEventMetadata('Atualizou uma categoria de perda', metadata, this.lost_reason, lost_reason)
      }
    }
  }

  exports.default = helpers.vue_include(view_model, helpers.form)
</script>

<style lang="sass" scoped>

  @import "../../assets/stylesheets/_variables.sass"

  input.form-control
    height: 38px

  .table-col
    padding-left: 20px
    padding-right: 20px
  .btn
    margin-left: 5px
</style>



// WEBPACK FOOTER //
// list_item.vue?c139e8d2